import { useCallback, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useBasePath } from '../../hooks/base-path/use-base-path.hook';
import { IMAGES_REPO } from '../../static-resources';
import { AppReportProblemModal } from './app-report-problem.modal';
import './app-report-problem.modal.scss';

export const AppReportProblemButtonComponent = () => {
  const [show, setShow] = useState(false);
  const handleReportProblem = useCallback(() => {
    setShow(true);
  }, []);
  const handleClose = useCallback(() => {
    setShow(false);
  }, []);
  const pageId = useBasePath();
  return (
    <>
      <ButtonGroup>
        <Button
          onClick={handleReportProblem}
          className="btn-outline btn-sm report-problem-button-component btn-default"
        >
          <img
            src={IMAGES_REPO.ReportProblemIcon}
            alt="Report a problem"
            height={20}
            width={20}
          />
        </Button>
      </ButtonGroup>
      <AppReportProblemModal
        show={show}
        onClose={handleClose}
        pageId={pageId}
      />
    </>
  );
};
